import script from "./CategoryTreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTreeNode.vue?vue&type=script&setup=true&lang=js"

import "./CategoryTreeNode.vue?vue&type=style&index=0&id=0f399b62&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f399b62"]])

export default __exports__